module.exports = __webpack_public_path__ + "static/img/detail_refund.f74e549f.svg";